const STORAGE_KEY = "certlex_notification_dismissed";

export function initNotificationOverlay(): void {
  const overlay = document.getElementById("notification-overlay");
  if (!overlay) return;

  const contentHash = overlay.dataset.contentHash;
  if (localStorage.getItem(STORAGE_KEY) === contentHash) return;

  const backdrop = overlay.querySelector(".notification-backdrop");
  const content = overlay.querySelector(".notification-content > div");
  const closeButton = overlay.querySelector(".notification-close");

  const show = () => {
    overlay.classList.remove("hidden");

    requestAnimationFrame(() => {
      backdrop?.classList.add("opacity-100");
      backdrop?.classList.remove("opacity-0");

      content?.classList.add("scale-100", "opacity-100");
      content?.classList.remove("scale-95", "opacity-0");
    });
  };

  const handleKeydown = (e: KeyboardEvent) => {
    if (e.key === "Escape" && !overlay.classList.contains("hidden")) {
      dismiss();
    }
  };

  const dismiss = () => {
    backdrop?.classList.remove("opacity-100");
    backdrop?.classList.add("opacity-0");

    content?.classList.remove("scale-100", "opacity-100");
    content?.classList.add("scale-95", "opacity-0");

    setTimeout(() => {
      overlay.classList.add("hidden");
    }, 300);

    if (contentHash) {
      localStorage.setItem(STORAGE_KEY, contentHash);
    }

    document.removeEventListener("keydown", handleKeydown);
  };

  closeButton?.addEventListener("click", dismiss);
  backdrop?.addEventListener("click", dismiss);
  document.addEventListener("keydown", handleKeydown);

  const delay = parseInt(overlay.dataset.delay || "0", 10) * 1000;

  if (delay > 0) {
    setTimeout(show, delay);
  } else {
    show();
  }
}
